"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocalStorage = exports.hasLocalStorage = exports.checkForLocalStorage = void 0;
/* ++++++++++ --------------- LOCAL STORAGE EXPORTS --------------- ++++++++++ */
// used mostly for messaging the user via notifications, toasters, and incontent messages

var checkForLocalStorage = function checkForLocalStorage() {
  try {
    window.localStorage.setItem("__test", "data");
    window.localStorage.removeItem("__test");
  } catch (e) {
    return false;
  }

  return true;
};

exports.checkForLocalStorage = checkForLocalStorage;

var hasLocalStorage = function hasLocalStorage(key) {
  return checkForLocalStorage() && window.localStorage.getItem(key);
};

exports.hasLocalStorage = hasLocalStorage;

var setLocalStorage = function setLocalStorage(key) {
  if (!hasLocalStorage(key)) window.localStorage.setItem(key, 'true');
};

exports.setLocalStorage = setLocalStorage;